// admin-lte の data-widget="pushmenu" / "treeview" 動作を最小再現
const MOBILE_MQ = window.matchMedia('(max-width: 767.98px)');

// .sidebar を keyboard scroll 可能にする（PageUp/Down をサイドバー内に閉じる）
document.addEventListener('DOMContentLoaded', () => {
  const sidebar = document.querySelector('.sidebar');
  if (sidebar && !sidebar.hasAttribute('tabindex')) {
    sidebar.setAttribute('tabindex', '-1');
  }
});

document.addEventListener('click', function (e) {
  // pushmenu: サイドバーの開閉
  const pushBtn = e.target.closest('[data-widget="pushmenu"]');
  if (pushBtn) {
    e.preventDefault();
    if (MOBILE_MQ.matches) {
      document.body.classList.toggle('sidebar-open');
    } else {
      document.body.classList.toggle('sidebar-collapse');
    }
    return;
  }

  // モバイル: バックドロップ/コンテンツタップで閉じる
  if (MOBILE_MQ.matches && document.body.classList.contains('sidebar-open')) {
    if (!e.target.closest('.main-sidebar') && !e.target.closest('[data-widget="pushmenu"]')) {
      document.body.classList.remove('sidebar-open');
    }
  }

  // treeview: 親リンク (href="#") をクリックしたらサブメニューを開閉
  const treeviewLink = e.target.closest('.has-treeview > .nav-link');
  if (treeviewLink && treeviewLink.getAttribute('href') === '#') {
    e.preventDefault();
    const parent = treeviewLink.parentElement;
    const submenu = parent.querySelector(':scope > .nav-treeview');
    if (submenu) {
      // HAML 側で `style="display: block;"` がインラインに付いている箇所が
      // あるため、CSS ルールが効くようにインラインスタイルをクリア
      submenu.style.display = '';
    }
    parent.classList.toggle('menu-open');
  }
});

// .sidebar 内でホイール/キー操作のときフォーカスをそちらへ寄せる
document.addEventListener('wheel', (e) => {
  const sidebar = e.target.closest('.sidebar');
  if (sidebar && document.activeElement !== sidebar) {
    sidebar.focus({ preventScroll: true });
  }
}, { passive: true });
